export default {
  "content": "<title>Icons/Bar Chart</title><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#DFF5EE\" cx=\"24\" cy=\"24\" r=\"24\"/><g stroke=\"#27A4BD\" stroke-width=\"2\"><path d=\"M22 12h5v24h-5zM32 19h5v17h-5zM11 25h5v11h-5z\"/></g></g>",
  "attrs": {
    "width": "48",
    "height": "48",
    "viewBox": "0 0 48 48",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};